import { HttpError } from 'react-admin';

const authProvider = {
	login: async ({ username, password }: { username: string; password: string }) => {
		const request = new Request('/api/login/', {
			method: 'POST',
			body: JSON.stringify({ loginid: username, password }),
			headers: new Headers({ 'Content-Type': 'application/json' }),
		});
		
		const response = await fetch(request);
		if (!response.ok) {
			throw new Error('ログインに失敗しました');
		}
		
		const { token, data } = await response.json();
		localStorage.setItem('auth_token', token);
		localStorage.setItem('data', JSON.stringify(data));
		
		return Promise.resolve();
	},
	
	logout: () => {
		localStorage.removeItem('auth_token');
		localStorage.removeItem('data');
		return Promise.resolve();
	},
	
	checkAuth: () => {
		return localStorage.getItem('auth_token') ? Promise.resolve() : Promise.reject();
	},
	
	checkError: (error: HttpError) => {
		if (error.status === 401 || error.status === 403) {
			localStorage.removeItem('auth_token');
			return Promise.reject();
		}
		return Promise.resolve();
	},
	
	// 権限
	getPermissions: () => {
		const data = localStorage.getItem('data');
		if (!data) return Promise.reject();
		const { role } = JSON.parse(data);
		return Promise.resolve(role);
	},
	
	// ユーザー情報
	getIdentity: () => {
		const data = localStorage.getItem('data');
		if (!data) return Promise.reject();
		const { id, name, kana, role } = JSON.parse(data);
		return Promise.resolve({
			id,
			name,
			kana,
			role,
		});
	},
};

export default authProvider;
